// Etiquetas legibles para los valores por defecto de los catálogos
// "forma_notificacion" y "origen_notificado" (Configuración > Centro
// Conciliación). "trabajador"/"actuario" y "empresa"/"despacho" son los
// códigos que ya se guardan en los expedientes prejudiciales; cualquier
// opción nueva que se agregue en Configuración se muestra tal cual se
// escribió, sin entrar en este mapa.
export const FORMA_NOTIFICACION_LABELS = {
  trabajador: "Solicitante",
  actuario: "Notificador CCL",
};

export const ORIGEN_NOTIFICADO_LABELS = {
  empresa: "Empresa",
  despacho: "Despacho",
};

export const formaNotificacionLabel = (codigo) =>
  FORMA_NOTIFICACION_LABELS[codigo] || codigo;

export const origenNotificadoLabel = (codigo) =>
  ORIGEN_NOTIFICADO_LABELS[codigo] || codigo;
